import React from 'react'
import Table from './table'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Grid, Divider, Typography, Tooltip } from '@material-ui/core'

class BotReportTable extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'BotReportTable')
        }
    }

    data = []

    componentDidMount() {
        this.totalTable.SetData([
            {
                bet: utils.currencyFormatter(0),
                bet_bt: utils.currencyFormatter(0),
                bet_count: 0,
                bet_bt_count: 0,
                profit_bt: utils.currencyFormatter(0),
                profit_nbt: utils.currencyFormatter(0),
                tax_bt: utils.currencyFormatter(0),
                tax: utils.currencyFormatter(0),
            },
        ])

        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    totalColumns = [
        {
            title: '总交易金额',
            render: (rowData) => {
                return (
                    <Tooltip
                        placement="top-start"
                        title={
                            utils.currencyFormatter(rowData.bet_bt) +
                            '(BOT) / ' +
                            utils.currencyFormatter(rowData.bet) +
                            ' = ' +
                            utils.currencyFormatter((rowData.bet_bt / rowData.bet) * 100) +
                            '%'
                        }>
                        <span>{utils.currencyFormatter(rowData.bet)}</span>
                    </Tooltip>
                )
            },
        },
        {
            title: '总交易笔数',
            field: 'bet',
            render: (rowData) => {
                return (
                    <Tooltip
                        placement="top-start"
                        title={
                            rowData.bet_bt_count +
                            '(BOT) / ' +
                            rowData.bet_count +
                            ' = ' +
                            utils.currencyFormatter((rowData.bet_bt_count / rowData.bet_count) * 100) +
                            '%'
                        }>
                        <span>{rowData.bet_count}</span>
                    </Tooltip>
                )
            },
        },
        {
            title: 'BOT输赢',
            field: 'profit_bt',
            render: (rowData) => {
                return utils.currencyFormatter(rowData.profit_bt)
            },
        },
        {
            title: 'BOT抽水',
            field: 'tax_bt',
            render: (rowData) => {
                return utils.currencyFormatter(rowData.tax_bt)
            },
        },
        {
            title: '总抽水',
            field: 'tax',
            render: (rowData) => {
                return utils.currencyFormatter(rowData.tax)
            },
        },
    ]

    columns = [
        {
            title: '编号',
            field: 'no',
        },
        {
            title: '游戏名称',
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        // avoid shadow copy
        ...utils.deepCopy(this.totalColumns),
    ]

    queryData = (queryParams) => {
        this.table.SetLoading(true)
        this.totalTable.SetLoading(true)

        utils.apiRequest(
            'get',
            API.BOT_RECORD_LIST_BY_GAME,
            queryParams,
            (data) => {
                var sumPerGameCode = {}
                var count = 0
                var newNo = 0
                data.sort((a, b) => (a.game_code === b.game_code ? (a.room_type > b.room_type ? 1 : -1) : a.game_code > b.game_code ? 1 : -1))
                data.forEach((item) => {
                    if (sumPerGameCode[item.game_code] === undefined) {
                        sumPerGameCode[item.game_code] = {
                            ...item,
                            id: ++count,
                            no: ++newNo,
                            room_type: undefined,
                        }
                    } else {
                        Object.keys(sumPerGameCode[item.game_code]).forEach((key) => {
                            if (['game_code', 'room_type', 'no', 'id'].indexOf(key) === -1) sumPerGameCode[item.game_code][key] += item[key]
                        })
                    }
                    item.id = ++count
                    item.no = undefined
                    item.parent = sumPerGameCode[item.game_code].id
                })
                this.data = data.concat(Object.values(sumPerGameCode))

                this.table.SetData(this.data)

                this.calculateTotal()
            },
            (_err) => {
                this.data = []
                this.table.SetData(this.data)
                this.calculateTotal()
            }
        )
    }

    calculateTotal = () => {
        let bet = 0,
            bet_bt = 0,
            bet_count = 0,
            bet_bt_count = 0,
            profit_bt = 0,
            profit_nbt = 0,
            tax_bt = 0,
            tax = 0
        this.data.forEach((item) => {
            if (item.parent !== undefined) return
            bet += item.bet
            bet_bt += item.bet_bt
            bet_count += item.bet_count
            bet_bt_count += item.bet_bt_count
            profit_bt += item.profit_bt
            profit_nbt += item.profit_nbt
            tax_bt += item.tax_bt
            tax += item.tax
        })

        const totalData = [
            {
                bet: bet,
                bet_bt: bet_bt,
                bet_count: bet_count,
                bet_bt_count: bet_bt_count,
                profit_bt: profit_bt,
                profit_nbt: profit_nbt,
                tax_bt: tax_bt,
                tax: tax,
            },
        ]
        this.totalTable.SetData(totalData)
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{this.t('total')}</Typography>
                    <Table
                        ownerName="BotReportTable"
                        columns={this.totalColumns}
                        options={{
                            paging: false,
                            search: false,
                            sorting: false,
                            toolbar: false,
                            showTitle: false,
                            rowStyle: (_rowData) => ({
                                height: '55px',
                            }),
                            headerStyle: {
                                whiteSpace: 'nowrap',
                            },
                        }}
                        onRef={(ref) => {
                            this.totalTable = ref
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="BotReportTable"
                        columns={this.columns}
                        options={{ export: true }}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                        onRef={(ref) => {
                            this.table = ref
                        }}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {
        root: {
            width: '100%',
            overflowX: 'auto',
        },
        title: {
            flex: '0 0 auto',
        },
        table: {
            minWidth: 650,
        },
        hide: {
            display: 'none',
        },
    }
}

BotReportTable.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
}

export default hoc(styles)(BotReportTable)
